// extracted by mini-css-extract-plugin
export default {"panel":"DesktopAfterUserChoosePanel_panel__5Yfvy"};